import { render, staticRenderFns } from "./ColorDetail.vue?vue&type=template&id=46b29480&scoped=true"
import script from "./ColorDetail.vue?vue&type=script&lang=js"
export * from "./ColorDetail.vue?vue&type=script&lang=js"
import style0 from "./ColorDetail.vue?vue&type=style&index=0&id=46b29480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b29480",
  null
  
)

export default component.exports